<template>
  <div class="campaign">
    <!-- <div class="campaignSideBar">
      <sidebar-menu  :class="{noSidebar : isSidebar}"/>
    </div> -->
    <div class="campaign__main">
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar/Desktop"

export default {
  name: 'adx-campaign',
  components: {
    'sidebar-menu': SideBar
  },
  props: {

  },
  data() {
    return {
      
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
   
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  },
  computed: {
    isSidebar(){
      const routerName = this.$route.name

      if(routerName == 'terminal'){
        return true
      }
      return false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>